import { render, staticRenderFns } from "./EventToday.vue?vue&type=template&id=1ebfe57e&scoped=true"
import script from "./EventToday.vue?vue&type=script&lang=js"
export * from "./EventToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebfe57e",
  null
  
)

export default component.exports